// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/driver.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Address, Base, ID, Point } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/driver.proto.
 */
export const file_transportation_v1_driver: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_types]);

/**
 * Driver message definition
 *
 * @generated from message transportation.v1.Driver
 */
export type Driver = Message<"transportation.v1.Driver"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID user_id = 2;
   */
  userId?: ID;

  /**
   * @generated from field: string first_name = 3;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 4;
   */
  lastName: string;

  /**
   * @generated from field: string license_number = 5;
   */
  licenseNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_expiration = 6;
   */
  licenseExpiration?: Timestamp;

  /**
   * @generated from field: transportation.v1.DriverStatus status = 7;
   */
  status: DriverStatus;

  /**
   * @generated from field: types.Point current_location = 8;
   */
  currentLocation?: Point;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 9;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: string phone_number = 10;
   */
  phoneNumber: string;

  /**
   * @generated from field: string email = 11;
   */
  email: string;

  /**
   * @generated from field: types.Address address = 12;
   */
  address?: Address;

  /**
   * @generated from field: types.ID default_truck_id = 13;
   */
  defaultTruckId?: ID;

  /**
   * @generated from field: types.ID default_trailer_id = 14;
   */
  defaultTrailerId?: ID;

  /**
   * @generated from field: types.Base base = 15;
   */
  base?: Base;
};

/**
 * Describes the message transportation.v1.Driver.
 * Use `create(DriverSchema)` to create a new message.
 */
export const DriverSchema: GenMessage<Driver> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 0);

/**
 * Request/Response messages for Driver queries
 *
 * @generated from message transportation.v1.GetDriverRequest
 */
export type GetDriverRequest = Message<"transportation.v1.GetDriverRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.GetDriverRequest.
 * Use `create(GetDriverRequestSchema)` to create a new message.
 */
export const GetDriverRequestSchema: GenMessage<GetDriverRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 1);

/**
 * @generated from message transportation.v1.GetDriverResponse
 */
export type GetDriverResponse = Message<"transportation.v1.GetDriverResponse"> & {
  /**
   * @generated from field: transportation.v1.Driver driver = 1;
   */
  driver?: Driver;
};

/**
 * Describes the message transportation.v1.GetDriverResponse.
 * Use `create(GetDriverResponseSchema)` to create a new message.
 */
export const GetDriverResponseSchema: GenMessage<GetDriverResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 2);

/**
 * @generated from message transportation.v1.ListDriversRequest
 */
export type ListDriversRequest = Message<"transportation.v1.ListDriversRequest"> & {
  /**
   * @generated from field: transportation.v1.ListDriversFilter filter = 1;
   */
  filter?: ListDriversFilter;

  /**
   * @generated from field: repeated transportation.v1.DriverSortOption sorting = 2;
   */
  sorting: DriverSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message transportation.v1.ListDriversRequest.
 * Use `create(ListDriversRequestSchema)` to create a new message.
 */
export const ListDriversRequestSchema: GenMessage<ListDriversRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 3);

/**
 * @generated from message transportation.v1.ListDriversFilter
 */
export type ListDriversFilter = Message<"transportation.v1.ListDriversFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue first_name = 2;
   */
  firstName?: string;

  /**
   * @generated from field: google.protobuf.StringValue last_name = 3;
   */
  lastName?: string;

  /**
   * @generated from field: google.protobuf.StringValue license_number = 4;
   */
  licenseNumber?: string;

  /**
   * @generated from field: transportation.v1.DriverStatus status = 5;
   */
  status: DriverStatus;

  /**
   * @generated from field: google.protobuf.StringValue phone_number = 6;
   */
  phoneNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue email = 7;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 8;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 9;
   */
  organizationId?: ID;

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_at = 10;
   */
  lastUpdatedAt?: Timestamp;

  /**
   * @generated from field: types.ID hauler_id = 11;
   */
  haulerId?: ID;

  /**
   * @generated from field: bool has_active_tasks = 12;
   */
  hasActiveTasks: boolean;
};

/**
 * Describes the message transportation.v1.ListDriversFilter.
 * Use `create(ListDriversFilterSchema)` to create a new message.
 */
export const ListDriversFilterSchema: GenMessage<ListDriversFilter> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 4);

/**
 * @generated from message transportation.v1.ListDriversResponse
 */
export type ListDriversResponse = Message<"transportation.v1.ListDriversResponse"> & {
  /**
   * @generated from field: repeated transportation.v1.Driver drivers = 1;
   */
  drivers: Driver[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message transportation.v1.ListDriversResponse.
 * Use `create(ListDriversResponseSchema)` to create a new message.
 */
export const ListDriversResponseSchema: GenMessage<ListDriversResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 5);

/**
 * Command messages
 *
 * @generated from message transportation.v1.CreateDriverRequest
 */
export type CreateDriverRequest = Message<"transportation.v1.CreateDriverRequest"> & {
  /**
   * @generated from field: transportation.v1.DriverInput input = 1;
   */
  input?: DriverInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.CreateDriverRequest.
 * Use `create(CreateDriverRequestSchema)` to create a new message.
 */
export const CreateDriverRequestSchema: GenMessage<CreateDriverRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 6);

/**
 * @generated from message transportation.v1.CreateDriverResponse
 */
export type CreateDriverResponse = Message<"transportation.v1.CreateDriverResponse"> & {
  /**
   * @generated from field: transportation.v1.Driver driver = 1;
   */
  driver?: Driver;
};

/**
 * Describes the message transportation.v1.CreateDriverResponse.
 * Use `create(CreateDriverResponseSchema)` to create a new message.
 */
export const CreateDriverResponseSchema: GenMessage<CreateDriverResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 7);

/**
 * @generated from message transportation.v1.UpdateDriverRequest
 */
export type UpdateDriverRequest = Message<"transportation.v1.UpdateDriverRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.DriverUpdateInput input = 2;
   */
  input?: DriverUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UpdateDriverRequest.
 * Use `create(UpdateDriverRequestSchema)` to create a new message.
 */
export const UpdateDriverRequestSchema: GenMessage<UpdateDriverRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 8);

/**
 * @generated from message transportation.v1.UpdateDriverResponse
 */
export type UpdateDriverResponse = Message<"transportation.v1.UpdateDriverResponse"> & {
  /**
   * @generated from field: transportation.v1.Driver driver = 1;
   */
  driver?: Driver;
};

/**
 * Describes the message transportation.v1.UpdateDriverResponse.
 * Use `create(UpdateDriverResponseSchema)` to create a new message.
 */
export const UpdateDriverResponseSchema: GenMessage<UpdateDriverResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 9);

/**
 * @generated from message transportation.v1.DeleteDriverRequest
 */
export type DeleteDriverRequest = Message<"transportation.v1.DeleteDriverRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.DeleteDriverRequest.
 * Use `create(DeleteDriverRequestSchema)` to create a new message.
 */
export const DeleteDriverRequestSchema: GenMessage<DeleteDriverRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 10);

/**
 * Input messages
 *
 * @generated from message transportation.v1.DriverInput
 */
export type DriverInput = Message<"transportation.v1.DriverInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID user_id = 2;
   */
  userId?: ID;

  /**
   * @generated from field: string first_name = 3;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 4;
   */
  lastName: string;

  /**
   * @generated from field: string license_number = 5;
   */
  licenseNumber: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_expiration = 6;
   */
  licenseExpiration?: Timestamp;

  /**
   * @generated from field: transportation.v1.DriverStatus status = 7;
   */
  status: DriverStatus;

  /**
   * @generated from field: types.Point current_location = 8;
   */
  currentLocation?: Point;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 9;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: string phone_number = 10;
   */
  phoneNumber: string;

  /**
   * @generated from field: string email = 11;
   */
  email: string;

  /**
   * @generated from field: types.Address address = 12;
   */
  address?: Address;

  /**
   * @generated from field: types.ID default_truck_id = 13;
   */
  defaultTruckId?: ID;

  /**
   * @generated from field: types.ID default_trailer_id = 14;
   */
  defaultTrailerId?: ID;
};

/**
 * Describes the message transportation.v1.DriverInput.
 * Use `create(DriverInputSchema)` to create a new message.
 */
export const DriverInputSchema: GenMessage<DriverInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 11);

/**
 * @generated from message transportation.v1.DriverUpdateInput
 */
export type DriverUpdateInput = Message<"transportation.v1.DriverUpdateInput"> & {
  /**
   * @generated from field: types.ID user_id = 1;
   */
  userId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue first_name = 2;
   */
  firstName?: string;

  /**
   * @generated from field: google.protobuf.StringValue last_name = 3;
   */
  lastName?: string;

  /**
   * @generated from field: google.protobuf.StringValue license_number = 4;
   */
  licenseNumber?: string;

  /**
   * @generated from field: google.protobuf.Timestamp license_expiration = 5;
   */
  licenseExpiration?: Timestamp;

  /**
   * @generated from field: transportation.v1.DriverStatus status = 6;
   */
  status: DriverStatus;

  /**
   * @generated from field: google.protobuf.StringValue current_location = 7;
   */
  currentLocation?: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 8;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue phone_number = 9;
   */
  phoneNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue email = 10;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.StringValue address = 11;
   */
  address?: string;

  /**
   * @generated from field: types.ID default_truck_id = 12;
   */
  defaultTruckId?: ID;

  /**
   * @generated from field: types.ID default_trailer_id = 13;
   */
  defaultTrailerId?: ID;
};

/**
 * Describes the message transportation.v1.DriverUpdateInput.
 * Use `create(DriverUpdateInputSchema)` to create a new message.
 */
export const DriverUpdateInputSchema: GenMessage<DriverUpdateInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_driver, 12);

/**
 * DriverStatus enum
 *
 * @generated from enum transportation.v1.DriverStatus
 */
export enum DriverStatus {
  /**
   * @generated from enum value: DRIVER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DRIVER_STATUS_AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: DRIVER_STATUS_ON_DUTY = 2;
   */
  ON_DUTY = 2,

  /**
   * @generated from enum value: DRIVER_STATUS_OFF_DUTY = 3;
   */
  OFF_DUTY = 3,

  /**
   * @generated from enum value: DRIVER_STATUS_ON_BREAK = 4;
   */
  ON_BREAK = 4,

  /**
   * @generated from enum value: DRIVER_STATUS_INACTIVE = 5;
   */
  INACTIVE = 5,
}

/**
 * Describes the enum transportation.v1.DriverStatus.
 */
export const DriverStatusSchema: GenEnum<DriverStatus> = /*@__PURE__*/
  enumDesc(file_transportation_v1_driver, 0);

/**
 * @generated from enum transportation.v1.DriverSortOption
 */
export enum DriverSortOption {
  /**
   * @generated from enum value: DRIVER_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_FIRST_NAME_ASC = 1;
   */
  FIRST_NAME_ASC = 1,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_FIRST_NAME_DESC = 2;
   */
  FIRST_NAME_DESC = 2,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_LAST_NAME_ASC = 3;
   */
  LAST_NAME_ASC = 3,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_LAST_NAME_DESC = 4;
   */
  LAST_NAME_DESC = 4,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_LICENSE_EXPIRATION_ASC = 5;
   */
  LICENSE_EXPIRATION_ASC = 5,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_LICENSE_EXPIRATION_DESC = 6;
   */
  LICENSE_EXPIRATION_DESC = 6,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_STATUS_ASC = 7;
   */
  STATUS_ASC = 7,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_STATUS_DESC = 8;
   */
  STATUS_DESC = 8,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_LAST_LOCATION_TIME_ASC = 9;
   */
  LAST_LOCATION_TIME_ASC = 9,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_LAST_LOCATION_TIME_DESC = 10;
   */
  LAST_LOCATION_TIME_DESC = 10,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_CREATED_AT_ASC = 11;
   */
  CREATED_AT_ASC = 11,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_CREATED_AT_DESC = 12;
   */
  CREATED_AT_DESC = 12,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_UPDATED_AT_ASC = 13;
   */
  UPDATED_AT_ASC = 13,

  /**
   * @generated from enum value: DRIVER_SORT_OPTION_UPDATED_AT_DESC = 14;
   */
  UPDATED_AT_DESC = 14,
}

/**
 * Describes the enum transportation.v1.DriverSortOption.
 */
export const DriverSortOptionSchema: GenEnum<DriverSortOption> = /*@__PURE__*/
  enumDesc(file_transportation_v1_driver, 1);

/**
 * Services
 *
 * @generated from service transportation.v1.DriverQueriesService
 */
export const DriverQueriesService: GenService<{
  /**
   * @generated from rpc transportation.v1.DriverQueriesService.GetDriver
   */
  getDriver: {
    methodKind: "unary";
    input: typeof GetDriverRequestSchema;
    output: typeof GetDriverResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.DriverQueriesService.ListDrivers
   */
  listDrivers: {
    methodKind: "unary";
    input: typeof ListDriversRequestSchema;
    output: typeof ListDriversResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_driver, 0);

/**
 * @generated from service transportation.v1.DriverCommandsService
 */
export const DriverCommandsService: GenService<{
  /**
   * @generated from rpc transportation.v1.DriverCommandsService.CreateDriver
   */
  createDriver: {
    methodKind: "unary";
    input: typeof CreateDriverRequestSchema;
    output: typeof CreateDriverResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.DriverCommandsService.UpdateDriver
   */
  updateDriver: {
    methodKind: "unary";
    input: typeof UpdateDriverRequestSchema;
    output: typeof UpdateDriverResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.DriverCommandsService.DeleteDriver
   */
  deleteDriver: {
    methodKind: "unary";
    input: typeof DeleteDriverRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_driver, 1);

